import Vue from 'vue';
import Component from 'vue-class-component';
import { Action } from 'vuex-class';

import { UPDATE_URL } from '@/store/actions';
import { RootGetters } from '@/store/getters';
import { UpdateUriParams } from '@/store/modules/groupUriModule';

@Component({})
export default class GroupUriMixin extends Vue {
  @Action(UPDATE_URL)
  private updateParamsAction!: (params: UpdateUriParams) => void;

  updateUriParams(params: string) {
    const currentUri = '#' + this.getCurrentUri();
    if (currentUri) {
      this.updateParamsAction({ Uri: currentUri, Params: params, RemoveTrailingSlash: true });
    }
  }

  private getCurrentUri() {
    return (this.$attrs as { groupUri?: string })?.groupUri;
  }

  get currentUriParams() {
    const gettersT = this.$store?.getters as RootGetters;
    const groupUri = this.getCurrentUri();

    if (gettersT && groupUri) {
      return gettersT.currentUriParams(groupUri);
    }
    return null;
  }
}
